<p-confirmDialog key="offenderlookupconfirm" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>
<p-confirmDialog key="offenderlookupfinish" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Gallery of Offender hits-->
<div>
	<div *ngIf="CanPrint() == true" class="Buttons">
		<button [disabled]="IsLoading() == true" class="btn btn-success" (click)="onPrintPass()">Print Pass</button>
		<label>NOTE: You can now print from the App by going to Menu -> View Logs</label>
	</div>

	<p-dataView
		*ngIf="lstNotVerified.length > 0"
		#dv
		[value]="lstNotVerified"
		[paginator]="true"
		paginatorPosition="both"
		[rows]="9"
		[sortField]="sortField"
		[sortOrder]="sortOrder"
		layout="grid"
		[showCurrentPageReport]="true"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
	>
		<ng-template pTemplate="header">
			<div class="p-d-flex p-flex-column p-flex-md-row p-jc-md-between">
				<p-dropdown
					[disabled]="IsLoading() == true"
					[options]="sortOptions"
					[(ngModel)]="sortKey"
					placeholder="Sort By"
					(onChange)="onSortChange($event)"
					styleClass="p-mb-2 p-mb-md-0"
				></p-dropdown>
				<!-- <span class="p-input-icon-left p-mb-2 p-mb-md-0">
                    <i class="pi pi-search"></i>
                    <input type="search" pInputText placeholder="Search by Name" (input)="dv.filter($event.target.value)">
                </span> -->
			</div>
		</ng-template>
		<ng-template let-Offender pTemplate="gridItem">
			<div class="GridItem">
				<div
					class="ItemBorder"
					[style.Border]="Offender.IsFalseHit == true ? '2px solid Green' : Offender.IsVerified == true ? '2px solid Red' : '2px solid Orange'"
					[style.Background]="Offender.IsFalseHit == true ? '#00800030' : Offender.IsVerified == true ? '#ff000030' : '#ffa50030'"
				>
					<h4 *ngIf="Offender.IsVerified == false" class="InfoHeader">Waiting for Admin</h4>

					<div class="ItemGrid">
						<!--Top, Image-->
						<div class="ImgDiv">
							<img class="ImgBorder" [src]="Offender.OffenderPhoto" alt="Offender #{{ Offender.OffenderID }}" />
						</div>

						<!--Middle, Data-->
						<div class="InfoColGrid">
							<label>DOB:</label>
							<p class="WrapText">{{ Offender.DOBDesc }}</p>

							<label>Offender Status:</label>
							<p class="WrapText">
								{{ Offender.OffenderStatus }}
							</p>

							<label>State:</label>
							<p class="WrapText">{{ Offender.State }}</p>

							<label>Conviction Place:</label>
							<p class="WrapText">
								{{ Offender.ConvictionPlace }}
							</p>

							<label>Race:</label>
							<p class="WrapText">{{ Offender.Race }}</p>

							<label>Sex:</label>
							<p class="WrapText">{{ Offender.Sex }}</p>

							<label>Height:</label>
							<p class="WrapText">{{ Offender.Height }}</p>

							<label>Weight:</label>
							<p class="WrapText">{{ Offender.Weight }}</p>

							<label>Hair Color:</label>
							<p class="WrapText">{{ Offender.HairColor }}</p>

							<label>Eye Color:</label>
							<p class="WrapText">{{ Offender.EyeColor }}</p>

							<label>Last updated by:</label>
							<p class="WrapText">{{ Offender.AdminName }}</p>

							<label>Last Updated:</label>
							<p class="WrapText">{{ Offender.c_dateDesc }}</p>
						</div>

						<!--Buttons-->
						<div>
							<!-- <div class="ButtonHeader">
                                <label>Visitor matches Offender Hit?</label>
                            </div>
                            <div class="ButtonDiv">
                                <button class="btn btn-success CheckButton" [disabled]="IsLoading() == true" (click)="onMatch(Offender)">
                                    <i class="fa fa-check" aria-hidden="true"></i>
                                </button>
                                <button class="btn btn-danger CheckButton" [disabled]="IsLoading() == true" (click)="onNoMatch(Offender)">
                                    <i class="fa fa-times" aria-hidden="true"></i>
                                </button>
                            </div> -->

							<div class="ButtonDiv">
								<button class="btn btn-danger CheckButton" [disabled]="IsLoading() == true" (click)="onMatch(Offender)">
									Visitor MATCHES Offender
								</button>
								<button class="btn btn-success CheckButton" [disabled]="IsLoading() == true" (click)="onNoMatch(Offender)">
									Visitor DOES NOT MATCH Offender
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</ng-template>
	</p-dataView>
</div>

<!--Table of Already Verified Results-->
<div *ngIf="lstVerified.length > 0">
	<caass-ms-offender-verified-table [lstOffender]="lstVerified" (onRefresh)="onRefresh()"> </caass-ms-offender-verified-table>
</div>
